import { Tooltip } from 'antd'
import { ArrowRightOutlined, CloseSquareTwoTone, SwapOutlined } from '@ant-design/icons'
import TrailerImg from '@assets/CustomIcons/trailer.svg'
import React, { useState } from 'react'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { useSecurityContext } from '@components/Navigation/SecurityContext'

export const TrailerSwapActionBlock = ({ removeAction, actionBlock, isBlocked }) => {
  const { scopes } = useSecurityContext()
  const canEdit = !isBlocked && scopes?.order_dispatch.edit
  const [showX, setShowX] = useState(false)
  return (
    <Tooltip
      destroyTooltipOnHide={{ keepParent: false }}
      open={showX}
      title={
        <Texto appearance='white'>
          {actionBlock?.details?.old_trailer_config} <ArrowRightOutlined />{' '}
          {actionBlock?.details?.new_trailer_config ?? 'N/A'}
        </Texto>
      }
    >
      <div
        onMouseEnter={() => {
          if (canEdit) setShowX(true)
        }}
        onMouseOver={() => {
          if (canEdit) setShowX(true)
        }}
        onMouseLeave={() => setShowX(false)}
        className='ab-trailer-swap h-100'
      >
        <img src={TrailerImg} alt='trailer' />
        {!showX && <SwapOutlined className='ab-image-transform-rotate' style={{ color: 'var(--theme-color-2)' }} />}
        {showX && canEdit && (
          <GraviButton
            style={{ background: 'transparent', padding: 0, width: '20px' }}
            icon={<CloseSquareTwoTone twoToneColor='#f22939' />}
            onClick={removeAction}
          />
        )}
        <img className='ab-image-transform-flip' src={TrailerImg} alt='trailer' />
      </div>
    </Tooltip>
  )
}
